<template>
    <component
        :is="menuName || 'selectSticker'"
        :stickers="stickers"
        :pageSelected="pageSelected"
        :editingSticker="menuName === 'linkMenu' ? overlayData : null"
        :dataStoryMakerDefault="dataStoryMakerDefault"
        :pagesSelectedIncludeConciergerie="pagesSelectedIncludeConciergerie"
        :backgroundIsVideo="backgroundIsVideo"
        @addSticker="addSticker"
        @updateSticker="updateSticker"
        @deleteSticker="deleteSticker"
        @changeMenu="changeMenu"
    />
</template>

<script>

import selectSticker from './SelectStickerMenuFacebook.vue';
import linkMenu from './LinkMenuFacebook.vue';
import musicMenu from './MusicMenuFacebook.vue';
import { stickerDataDefault } from './main.vue';

export default {

    components: {
        selectSticker,
        linkMenu,
        musicMenu,
    },

    props: {
        menuNameDefault: {
            type: String,
            default: ''
        },
        overlayData: {
            type: Object,
            default: null
        },
        stickers: Array,
        pageSelected: Object,
        dataStoryMakerDefault: Object,
        pagesSelectedIncludeConciergerie: Boolean,
        backgroundIsVideo: Boolean,
    },

    data() {
        return {
            menuName: 'selectSticker'
        }
    },

    methods: {
        addSticker(name, custom = {}) {
            if (!stickerDataDefault[name]) return
            const data = {...JSON.parse(JSON.stringify(stickerDataDefault[name])), ...custom}
            this.$emit('addSticker', data)
            this.$emit('close');
        },

        updateSticker(id, payload) {
            this.$emit('updateSticker', id, payload)
        },

        deleteSticker(id) {
            this.$emit('deleteSticker', id)
        },

        changeMenu(menuName) {
            this.menuName = menuName
            if (!menuName) {
                this.$emit('close');
            }
        }
    },

    watch: {
        menuNameDefault: {
            handler(newValue) {
                this.menuName = newValue
            },
            immediate: true
        }
    },
}
</script>
